import { CalendarOptions, EventInput, WeekNumberCalculation } from '@fullcalendar/common';
// must go before plugins
import dayGridPlugin from '@fullcalendar/daygrid';
// a plugin!
import interactionPlugin from '@fullcalendar/interaction';
import FullCalendar, { DateInput, addDays } from '@fullcalendar/react';
import { format, parseJSON } from 'date-fns';
import { utcToZonedTime, zonedTimeToUtc } from 'date-fns-tz';
import React from 'react';

import { formatAsUTCDate, readableDate } from '../../../libs/date';
// a plugin!
import './FullCalendarNew.scss';

export type FullCalendarNewProps = CalendarOptions & {
  disabled: boolean;
};

const ICONS = {
  prev: 'chevron-left',
  next: 'chevron-right',
  prevYear: 'chevrons-left', // double chevron
  nextYear: 'chevrons-right', // double chevron
};

export const FullCalendarNew = (props: FullCalendarNewProps) => {
  // const adjustedProps = props.disabled
  //   ? {
  //       ...props,
  //       editable: false,
  //       //@ts-ignore
  //       events: props?.events?.map(e => ({
  //         ...e,
  //         editable: false
  //       }))
  //     }
  //   : props;
  return (
    <div
      style={{
        height: '100%',
        pointerEvents: props.disabled ? 'none' : undefined,
        opacity: props.disabled ? 0.2 : undefined,
      }}
    >
      {/* @ts-ignore */}
      <FullCalendar
        plugins={[dayGridPlugin, interactionPlugin]}
        initialView="dayGridMonth"
        height="auto"
        weekNumberCalculation="ISO"
        buttonIcons={ICONS}
        {...props}
      />
    </div>
  );
};

export function extractDaysFromFullCalendarEvent(event: EventInput): string[] {
  if (!event.start || !event.end) {
    throw new Error('Event must have start and end');
  }

  if (Array.isArray(event.start) || Array.isArray(event.end)) {
    throw new Error('Event start and end must be dates');
  }

  const t = parseJSON(event.start);
  const t2 = parseJSON(event.end);

  return Array.from({
    length: (t2.getTime() - t.getTime()) / (60 * 1000 * 60 * 24),
  }).map((_, i) => format(addDays(t, i), 'yyyy-MM-dd'));
}

export function dateInputToDate(date: DateInput | undefined): Date {
  if (!date) {
    throw new Error('Date must be defined');
  }
  if (Array.isArray(date)) {
    throw new Error('Date must be a date');
  }
  if (!(date instanceof Date)) {
    return new Date(date);
  }
  return date;
}

export function addDaysRobust(date: DateInput | undefined, num: number): Date {
  return addDays(dateInputToDate(date), num);
}

export function isSameDay(date1: DateInput | undefined, date2: DateInput | undefined): boolean {
  return dateInputToDate(date1).getTime() === dateInputToDate(date2).getTime();
}

export function isSameDayIgnoreTZ(date1: Date | string, date2: Date | string): boolean {
  // this is fragile; our date manipulations may cause trouble with timezones.
  // TODO: review the whole day vs Date thing inside material requests,
  // it's quite psosible this will fail when we are physically located in different timezones.
  return readableDate(date1) === readableDate(date2);
}
